import { AccountsDashboardContent } from "components/AccountsDashboard/AccountsDashboardContent";
import { useProfile } from "library/hooks/auth/useProfile";
import { capitaliseEveryWord } from "library/utils";
import { Layout } from "../Layout/Layout";

export const AccountsDashboard = () => {
  const { profile } = useProfile();

  return (
    <Layout>
      <Layout.Header>Hello {capitaliseEveryWord(profile?.name)}</Layout.Header>
      <Layout.Main>
        <AccountsDashboardContent />
      </Layout.Main>
    </Layout>
  );
};
